export const SET_CURRENT_TENANT_PRICING_PLAN =
  "SET_CURRENT_TENANT_PRICING_PLAN";
